'use client';

import React, { type ReactElement, useContext, useMemo } from 'react';

import classNames from 'classnames';

import ButtonDiagonalLine from '@/common/components/button-diagonal-line/button-diagonal-line.component';
import Button, {
  type ButtonProps,
} from '@/common/components/button/button.component';
import { ButtonSelectContext } from '@/common/contexts/button-select-context';

interface ButtonSelectItemProps extends ButtonProps {
  value: string;
  ButtonClassName: string;
  notInStock?: boolean;
  notActive?: boolean;
}

const ButtonSelectItem = ({
  children,
  value,
  notInStock,
  notActive,
  ButtonClassName,
  ...rest
}: ButtonSelectItemProps): ReactElement => {
  const { checked, onClick, secondFeature, selectFeature, variant, features } =
    useContext(ButtonSelectContext);

  const secondFeat = secondFeature && variant[features[1]];
  const outOfStockFeat = useMemo(
    () => (secondFeature && notInStock) || (notActive && !secondFeature),
    [secondFeature, notInStock, notActive]
  );

  const onClickHandler = () => {
    if (outOfStockFeat) return;

    if (selectFeature) selectFeature(value);
    !notActive && onClick(value);
  };

  return (
    <Button
      {...rest}
      disabled={outOfStockFeat}
      onClick={onClickHandler}
      className={classNames(
        'button-select flex h-8 items-center justify-center gap-[3px] rounded-md p-0 text-xs !text-black-300 ',
        {
          '!bg-black-default !text-white':
            checked === value || (value === secondFeat && !outOfStockFeat),
        },
        {
          '!border !border-black-100 bg-transparent !text-black-200':
            outOfStockFeat,
        },
        ButtonClassName
      )}
    >
      {children}
      {outOfStockFeat && <ButtonDiagonalLine />}
    </Button>
  );
};

export default ButtonSelectItem;
